<template>
    <MainLayout selectMenu="9-1">
        
        <div v-if="!hasAuth">
            <NoAuth></NoAuth>
        </div>
        <div v-else class="register-container ">
            <Card class="card-container " dis-hover>
                <div slot="title" class="card-title">
                    {{ getTranslation('u086') }}
                </div>
                <div class="register-card">
                    <Row type="flex" class="form-row">
                        <Col flex="2">
                        <p class="description">MAC地址</p>
                        </Col>
                    </Row>
                    <Row type="flex" class="form-row menu-actions">
                        <Col flex="1" class="input-col">
                        <Input v-model="macAddress" />
                        </Col>
                    </Row>
                    <Row type="flex"> 
                        <Col flex="1" class="button-col">
                        &nbsp;<Button type="primary" @click="createFromMac" class="copy-btn">生成产品序列号和激活码</Button>
                        </Col>
                    </Row>
                    <Row type="flex" class="form-row menu-actions">
                        <Col flex="2">
                        <p class="description">产品序列号&nbsp;<Button type="warning" @click="copySerialNumber">复制</Button>
                        </p>
                        </Col>
                    </Row>

                    <Row type="flex" class="form-row menu-actions">
                        <Col flex="1" class="input-col">
                        <Input v-model="serialNumber" />
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1" class="button-col">
                        &nbsp;<Button type="info" @click="createFromSerialNumber" class="copy-btn">生成注册码</Button>
                        &nbsp;<Button type="success" @click="startScan()" class="copy-btn" icon="ios-camera-outline"></Button>
                        <div v-if="isScanning" class="scanner-container">
                <qrcode-stream
                    ref="qrReader"
                    @decode="onDecode"
                    @init="onInit"
                    :paused="paused"
                />
                <Button @click="stopScan" type="warning">关闭摄像头</Button>
                </div>
                        </Col>
                    </Row>

                    <Row type="flex" class="form-row">
                        <Col flex="2">
                        <p class="description">激活设备类型&nbsp;&nbsp;<Checkbox @on-change="toggleSelectAll">全选</Checkbox></p>
                        <div v-for="item in chkList" :key="item.id" class="one-machine">
                        <Checkbox v-model="levelBit[item.id]">{{item.name}}</Checkbox>
                        </div>
                        </Col>
                    </Row>

                    <Row type="flex" class="form-row menu-actions">
                        <Col flex="2">
                        <p class="label">激活码&nbsp;<Button type="warning" @click="copyRegistrationCode">复制</Button></p>
                        </Col>
                    </Row>
                    <Row type="flex" class="form-row menu-actions">
                        <Col flex="1" class="input-col">
                        <Input v-model="registrationCode" :placeholder="getTranslation('u089')" class="code-input" />
                        </Col>
                        </Row>
                <Row type="flex" class="form-row menu-actions">
                        <Col flex="1" class="button-col">
                        &nbsp;<Button type="success" @click="resetRegisterCode" class="copy-btn">还原序列号</Button>
                        </Col>
                    </Row>
                </div>
            </Card>
               
            
        </div>
    </MainLayout>
</template>

<script>
import MainLayout from '@/components/MainLayout.vue'
import NoAuth from '@/components/NoAuth.vue'
import { Card, Input, Button, Row, Col,Checkbox } from 'view-design'
import { mapGetters } from 'vuex'
import { API_URL } from '@/constants/const.js'
import axios from 'axios'
import { postJsError } from '@/util/util.js'
import { QrcodeStream } from 'vue-qrcode-reader'

export default {
    name: 'RegisterCreate',
    components: {
        MainLayout,
        NoAuth,
        Card,
        Input,
        Button,
        Row,
        Col,Checkbox,
        QrcodeStream,
    },
    props: {},
    data() {
        return {
            hasAuth: true,
            macAddress: '',
            serialNumber: '',
            registrationCode: '',
            isScanning: false,
            paused: false,
            chkList:[
                {'id':0,'name':'HRC-803中频焊机'},
                {'id':1,'name':'HRC-802'},
                {'id':2,'name':'HRC-A50'},
                {'id':3,'name':'HRC-501'},
                {'id':4,'name':'HRC-650焊接质量监控仪'},
                {'id':5,'name':'HRC-670铆接质量监控仪'},
                {'id':6,'name':'HRC-62交流焊机'}],
            levelBit:[],
            checkAll: false,
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
    },
    mounted() { },
    created() {
        this.setBreadcrumbItems()
        this.getData()
    },
    methods: {
        async getData() {
            const url = API_URL['registerInit']
            const res = await axios.get(url
            ).catch((err) => {
                postJsError(err)
            })
            if (res && res.data && res.data.code === 200) {
                
                this.macAddress = res.data.data.mac || '';
                this.hasAuth = true;
            } else if (res && res.data && res.data.code == 3001) {
                this.hasAuth = false;
            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
        },
        setBreadcrumbItems() {
            if (this.$lang && this.$lang['u085']) {
                this.$store.commit('setBreadcrumbItems', [
                    { title: this.getTranslation('u085') }
                ])
            }            
        },
        copySerialNumber() {
            if (!this.serialNumber) return
            navigator.clipboard.writeText(this.serialNumber)
                .then(() => {
                    this.$Message.success(this.getTranslation('u091'))
                })
                .catch(() => {
                    this.$Message.error(this.getTranslation('u092'))
                })
        },
        copyRegistrationCode() {
            if (!this.registrationCode) return
            navigator.clipboard.writeText(this.registrationCode)
                .then(() => {
                    this.$Message.success(this.getTranslation('u091'))
                })
                .catch(() => {
                    this.$Message.error(this.getTranslation('u092'))
                })
        },
        createFromMac() {
            if (!this.macAddress) {
                this.$Message.error("请填写MAC地址");
                return;
            }
          
            let data = new FormData();
            data.append("type", "fromMac");
            this.postRegistrationData(data);
        },
        createFromSerialNumber() {
            if (!this.macAddress) {
                this.$Message.error("请填写MAC地址");
                return;
            }
            let data = new FormData();
            data.append("type", "fromSerialNumber");
            this.postRegistrationData(data);
        },
        resetRegisterCode() {
            if (!this.registrationCode) {
                this.$Message.error("请输入注册码");
                return;
            }
            let data = new FormData();
            data.append("type", "reset");
            this.postRegistrationData(data);
        }, 
        postRegistrationData(data) {
            data.append("macAddress", this.macAddress);           
         
            data.append("serialNumber", this.serialNumber);
            data.append("registrationCode", this.registrationCode);
            data.append("levelBit", this.levelBit.join(","));
            const url = API_URL['registerCreate']
            axios.post(url, data
            ).then((res) => {
                if (res && res.data && res.data.code === 200) {
                    if( data.get("type") === "fromMac") {
                        this.serialNumber = res.data.data.serialNumber || '';
                        this.registrationCode = res.data.data.registrationCode || '';
                        this.$Message.success("产品序列号和注册码生成成功");
                    } else if(data.get("type") === "fromSerialNumber") {
                        this.registrationCode = res.data.data.registrationCode || '';
                        this.$Message.success("注册码生成成功");
                    } else if(data.get("type") === "reset") {
                        this.serialNumber = res.data.data.serialNumber || '';
                        this.levelBit = res.data.data.levelBit || [];
                        this.macAddress = res.data.data.macAddress || '';
                        this.$Message.success("序列号还原成功");
                    }
                } else if (res && res.data && res.data.msg) {
                    this.$Message.error(res.data.msg);
                } else {
                    this.$Message.error(this.getTranslation('c001'));
                }
            }).catch((err) => {
                postJsError(err)
            })
        },
        toggleSelectAll() {            
            if(!this.checkAll) {
                this.chkList.forEach((item) => {
                    this.$set(this.levelBit, item.id, true); // 确保响应式更新
                });
            } else {
                this.chkList.forEach((item) => {
                    this.$set(this.levelBit, item.id, false); // 确保响应式更新
                });
            }            
            this.checkAll = !this.checkAll;
        },
        startScan() {
            this.paused = false
            this.isScanning = true
        },
        stopScan() {
            this.paused = true
            this.isScanning = false
        },
        onDecode(result) {
            if (!result) {
                return
            }
            this.serialNumber = String(result).trim()
            this.$Message.success('扫码成功')
            this.stopScan()
        },
        async onInit(promise) {
            try {
                await promise
            } catch (error) {
                let msg = '摄像头初始化失败'
                if (error && error.name === 'NotAllowedError') {
                    msg = '请允许浏览器访问摄像头'
                } else if (error && error.name === 'NotFoundError') {
                    msg = '未检测到可用摄像头'
                } else if (error && error.name === 'NotSupportedError') {
                    msg = '当前页面环境不支持摄像头扫码，请使用 HTTPS 或 localhost'
                }
                this.$Message.error(msg)
                this.stopScan()
            }
        }
    },


}
</script>

<style scoped>
@import url('../../assets/style/list.css');
@import url('../../assets/style/tab.css');

.register-card {
    padding: 16px;
    width: 60%;
    margin: 0 auto;
    align-items: center;
    display: block;
    justify-content: center;
    border-radius: 12px;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);
    background: rgba(248, 249, 250, 255);

    color: rgba(50, 50, 93, 255);

    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    line-height: 25.6px;
    letter-spacing: 0px;
    text-align: left;


}

.form-row {
    margin-bottom: 6px;
}
.one-machine{
    width: 100%;
    display: block;
}
</style>
